import { useObserver } from "mobx-react";
import {
  AiOutlineCheck,
  AiOutlineCloseCircle,
} from "react-icons/ai";
import { useStores } from "../../../store";
import { useEffect, useRef, useState } from "react";
import { SlTag } from "react-icons/sl";
import { MdAddCircleOutline, MdOutlineDelete } from "react-icons/md";

export default function LabelPopup(props) {
  // using ref to get the value of the input field
  const userDetailslocal = JSON.parse(localStorage.getItem("user"));
  const name = useRef();
  const description = useRef();
  const Addcolor = useRef();
  const updateName = useRef();
  const updateDescription = useRef();
  const Updatecolor = useRef();
  const { PopupStore, RecuiterStore, LabelStore } = useStores();
  const [color, setColor] = useState(LabelStore.selectedLableValues?.color);
  const colorInputRef = useRef(null);
  const EditLabelSubmit = () => {
    const body = {
      name: updateName.current.value,
      description: updateDescription.current.value,
      color: Updatecolor.current.value,
    };
    LabelStore.selectedLableValues.color = Updatecolor.current.value;
    LabelStore.UpdateLabel(body).then((res) => {
      if (res) {
        console.log("Label updated");
        LabelStore.fetchLabelsData();
        // props.handleEdit();
      }
    });
    return;
  };

  const submitAddLabel = () => {
    // LabelStore.PostLabel(name.current.value, Addcolor.current.value, RecuiterStore.user._id);
    const body = {
      name: name.current.value,
      color: Addcolor.current.value,
      createdBy: userDetailslocal._id,
      description: description.current.value,
    };
    LabelStore.PostLabel(body);
    LabelStore.fetchLabelsData();
    PopupStore.setLabelPopup(false);
    console.log(name.current.value);
    console.log(Addcolor.current.value);
    console.log(userDetailslocal._id);
    // LabelStore.setLabelRefersher(true);
  };

  const colors = ["#f97316", "#3b82f6", "#eab308", "#22c55e"];

  const deleteLabel = () => {
    console.log("delete label");
    LabelStore.deleteLabel(LabelStore.selectedLabel);
    // LabelStore.setLabelRefersher(true);
  };
  useEffect(() => {
    setColor(LabelStore.selectedLableValues?.color);
  }, [LabelStore.selectedLableValues]);
  const [edit, setEdit] = useState(false);
  return useObserver(() => {
    return (
      <>
        {PopupStore.labelPopup && (
          <div
            className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-40"
            onClick={() => {
              PopupStore.setLabelPopup(false);
            }}
          >
            <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 px-5 z-50 flex flex-col justify-between rounded-3xl border  items-center md:w-[35%] lg:w-[30%] w-[95%] h-fit m-auto  overflow-y-auto no-scrollbar"
            >
              <AiOutlineCloseCircle
                className="absolute text-lg text-orange-500 cursor-pointer top-2 right-2"
                onClick={() => {
                  PopupStore.setLabelPopup(false);
                }}
              />

              {/* <h2 className="text-sm font-semibold mt-7 mb-3">Add New Label</h2> */}
              {/* <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitAddLabel();
                }}
                className="flex flex-col gap-6 items-start mx-auto px-20  h-fit py-5 w-[100%] md:w-[100%] lg:w-[100%]  rounded-xl overflow-y-auto"
              >
                <div className="px-5 py-2 border-2 outline-none flex gap-2 justify-between items-center w-full text-lg rounded-md">
                  <input
                    type="text"
                    ref={name}
                    placeholder="Enter name of the label"
                    className="w-full outline-none "
                  />
                  <input
                    type="color"
                    onChange={(e) => {
                      setColor(e.target.value);
                    }}
                    className="w-6 rounded-3xl h-7 border-none bg-transparent"
                    id="favcolor"
                    name="favcolor"
                    // value={color}
                    ref={Addcolor}
                  ></input>
                </div>

                <button className="py-2 text-sm px-6 font-semibold text-white ml-auto rounded-lg bg-primary ">
                  Add Label
                </button>
              </form> */}
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  submitAddLabel();
                }}
                className="w-[90%]"
              >
                <h2 className="text-lg font-normal mt-7 flex items-center gap-2 mb-2">
                  {" "}
                  <SlTag />
                  Add New Tag
                </h2>
                <div className="mb-4 ">
                  <label className="block w-fit  font-medium mb-1">Title</label>

                  <input
                    type="text"
                    ref={name}
                    name="title"
                    className="w-full p-2 border  text-sm rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500 "
                    placeholder="Enter the title of the Tag"
                  />
                </div>
                <div className="mb-4">
                  <label className="block w-fit  font-medium mb-1">
                    Description
                  </label>
                  <textarea
                    ref={description}
                    name="description"
                    className="w-full p-1  border rounded-lg text-sm  focus:outline-none focus:ring-1 focus:ring-orange-500  "
                    placeholder="Add  description...."
                    rows="6"
                  />
                  <label className="block w-fit font-medium mt-2 ">
                    Add Colour
                  </label>
                  <div className="mb-4">
                    <div className="  py-2 w-full justify-between rounded-lg mb-2 flex items-center flex-row  ">
                      <div className="flex">
                        {colors?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="w-5 h-5 ml-1 rounded-2xl border flex items-center justify-center"
                              style={{ backgroundColor: item }}
                              onClick={() => setColor(item)}
                            >
                              {item === color && (
                                <AiOutlineCheck className="text-white text-[10px] font-bold" />
                              )}
                            </div>
                          );
                        })}

                        <div
                          className="relative h-5 w-5 rounded-full border-2 ml-1 cursor-pointer"
                          style={{ backgroundColor: Addcolor }}
                          onClick={() => Addcolor.current.click()} // Trigger the color input on click
                        >
                          <input
                            type="color"
                            onChange={(e) => setColor(e.target.value)} // Update state on color change
                            className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                            ref={Addcolor} // Attach the ref
                            value={color}
                          />
                          <MdAddCircleOutline className="text-black text-[10px] absolute top-[20%] right-[20%]" />
                        </div>
                      </div>
                      <button className="py-1  px-8 font-normal text-white rounded-lg bg-primary ">
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}{" "}
        {PopupStore.labelEditPopup && (
          <div
            onClick={() => {
              PopupStore.setEditLabelPopup(false);
              setEdit(false);
            }}
            className="fixed inset-0 z-50 w-screen h-screen bg-black backdrop-filter backdrop-blur-sm bg-opacity-40"
          >
            {/* <div
              onClick={(e) => e.stopPropagation()}
              className="absolute  inset-0 bg-bg3 z-50 flex h-fit flex-col justify-center rounded-3xl border  items-center md:w-[35%] lg:w-[30%] w-[90%]  m-auto shadow-lg overflow-y-auto no-scrollbar"
            >
              <AiOutlineCloseCircle
                className="absolute text-xl cursor-pointer top-2 right-2"
                onClick={() => {
                  PopupStore.setEditLabelPopup(false);
                  setEdit(false);
                }}
              />
              <h1 className="text-2xl font-normal mt-9">Edit Label</h1>
              <div className="flex flex-col gap-4 px-20  items-center p-6  mt-3 h-full py-1 w-[100%] md:w-[100%] lg:[100%]  rounded-xl overflow-y-hidden no-scrollbar">
                <div className="px-5 py-3 border-2 outline-none flex gap-2 justify-between items-center w-full text-xl rounded-md">
                  <input
                    type="text"
                    placeholder="Enter name of the label"
                    ref={updateName}
                    defaultValue={LabelStore.selectedLableValues?.name}
                    onChange={() => setEdit(true)}
                    className="w-full outline-none "
                  />

                  <input
                    type="color"
                    ref={Updatecolor}
                    defaultValue={
                      LabelStore.selectedLableValues?.color || color
                    }
                    // value={color}
                    onChange={(e) => {
                      setColor(e.target.value);
                      setEdit(true);
                    }}
                    className="w-6 rounded-3xl h-7 border-none bg-transparent"
                    id="favcolor"
                    name="favcolor"
                  ></input>
                </div>
                <div className="flex w-full justify-between h-fit">
                  <button
                    onClick={() => {
                      deleteLabel();
                      PopupStore.setLabelEditPopup(false);
                      LabelStore.labels_list?.splice(
                        LabelStore.selectedIndex,
                        1
                      );
                      props.handleDelete();
                    }}
                    className=" mt-5 underline text-sm rounded-lg text-red-500 "
                  >
                    Delete
                  </button>
                  <button
                    onClick={() => {
                      EditLabelSubmit();
                      PopupStore.setLabelEditPopup(false);
                    }}
                    className=" mt-5 text-sm text-
                   rounded-lg py-2 px-5 bg-primary "
                  >
                    Update
                  </button>
                </div>
              </div>
            </div> */}
            <div
              onClick={(e) => {
                e.stopPropagation();
              }}
              className="absolute  inset-0 bg-bg3 px-5 z-50 flex flex-col justify-between rounded-3xl border  items-center md:w-[35%] lg:w-[30%] w-[95%] h-fit m-auto  overflow-y-auto no-scrollbar"
            >
              <AiOutlineCloseCircle
                className="absolute text-lg text-orange-500 cursor-pointer top-2 right-2"
                onClick={() => {
                  PopupStore.setEditLabelPopup(false);
                }}
              />
              <form
                onSubmit={() => {
                  EditLabelSubmit();
                  PopupStore.setLabelEditPopup(false);
                }}
                className="w-[90%]"
              >
                <h2 className=" text-lg font-normal mt-7 flex items-center gap-2 mb-2">
                  {" "}
                  <SlTag />
                  Edit Tag
                </h2>
                <div className="mb-4 ">
                  <label className="block font-medium mb-1">Title</label>

                  <input
                    type="text"
                    placeholder="Enter name of the label"
                    ref={updateName}
                    defaultValue={LabelStore.selectedLableValues?.name}
                    onChange={() => setEdit(true)}
                    className="w-full p-2 border   rounded-md focus:outline-none focus:ring-1 focus:ring-orange-500"
                  />
                </div>
                <div className="mb-4">
                  <label className="block font-medium mb-1">Description</label>
                  <textarea
                    ref={updateDescription}
                    defaultValue={LabelStore.selectedLableValues?.description}
                    name="description"
                    className="w-full p-1  border rounded-lg text-sm  focus:outline-none focus:ring-1 focus:ring-orange-500 "
                    placeholder="Add  description...."
                    rows="6"
                  />
                  <label className="block  font-medium mt-2 ">Add Colour</label>
                  <div className="mb-4">
                    <div className=" w-full  py-2 gap-1 rounded-lg mb-2 flex justify-between items-center flex-row  ">
                      <div className="flex gap-1">
                        {colors?.map((item, index) => {
                          return (
                            <div
                              key={index}
                              className="w-5 h-5 ml-1 rounded-2xl border flex items-center justify-center"
                              style={{ backgroundColor: item }}
                              onClick={() => {
                                setColor(item);
                                Updatecolor.current.value = item;
                              }}
                            >
                              {item === color && (
                                <AiOutlineCheck className="text-white text-[10px] font-bold" />
                              )}
                            </div>
                          );
                        })}

                        <div
                          className="relative h-5 w-5 rounded-full border-2 cursor-pointer"
                          style={{ backgroundColor: color }}
                          onClick={() => Updatecolor.current.click()} // Trigger the color input on click
                        >
                          <input
                            type="color"
                            ref={Updatecolor}
                            defaultValue={
                              LabelStore.selectedLableValues?.color || color
                            }
                            // value={color}
                            onChange={(e) => {
                              setColor(e.target.value);
                              setEdit(true);
                            }}
                            className="absolute top-0 left-0 w-full h-full opacity-0 cursor-pointer"
                            id="favcolor"
                            name="favcolor"
                          ></input>
                          <MdAddCircleOutline className="text-black text-[10px] absolute top-[20%] right-[20%]" />
                        </div>
                      </div>
                      <div className="flex items-center gap-2">
                        <button className="py-1 text-sm px-8 font-normal text-white rounded-lg bg-primary ">
                          Update
                        </button>
                        <MdOutlineDelete
                          className=" text-2xl cursor-pointer"
                          onClick={() => {
                            deleteLabel();
                            PopupStore.setLabelEditPopup(false);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}
      </>
    );
  });
}
